import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import globalProtectIcon from '~/modules/link-farm/components/LinkList/link-item-icons/globalProtectIcon.png?url';

interface RequiredVpnProps {
  visible: boolean;
}

export function RequiredVpn({ visible }: RequiredVpnProps) {
  const { t } = useTranslation('wmgone');

  return (
    <div
      className={cn(
        'flex flex-row items-center gap-xs opacity-none transition-opacity group-hover:opacity-full group-focus:opacity-full',
        !visible && 'hidden',
      )}
    >
      <img
        src={globalProtectIcon}
        className="size-lg rounded-full"
        alt="global-protect-icon"
      />
      <p className="text-body-xs">{t('links.item.vpnRequired')}</p>
    </div>
  );
}

RequiredVpn.displayName = 'RequiredVpn';
